export const CONFIGURATOR_MODES = {
    OVERVIEW: 0,
    SETTINGS: 1,
    EDITOR: 2,
    EXPORT: 3, 
    ACTIONS: 4,
}